import { weekdaysPrefix as SCHEDULE_WEEKDAYS_PREFIX } from './constants/format.json'

import * as Weekday from './constants/weekdays'

const parseWeekdays = rawWeekdayStr => {
  const defaultWeekdays = {
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
  }

  if (
    typeof rawWeekdayStr !== 'string' ||
    !rawWeekdayStr.startsWith(SCHEDULE_WEEKDAYS_PREFIX)
  ) {
    return defaultWeekdays
  }

  const theWeekdayStr = rawWeekdayStr.slice(SCHEDULE_WEEKDAYS_PREFIX.length)
  const theRawDays = Number(theWeekdayStr)

  if (Number.isNaN(theRawDays)) {
    return defaultWeekdays
  }

  return {
    monday: (theRawDays & Weekday.MONDAY) > 0,
    tuesday: (theRawDays & Weekday.TUESDAY) > 0,
    wednesday: (theRawDays & Weekday.WEDNESDAY) > 0,
    thursday: (theRawDays & Weekday.THURSDAY) > 0,
    friday: (theRawDays & Weekday.FRIDAY) > 0,
    saturday: (theRawDays & Weekday.SATURDAY) > 0,
    sunday: (theRawDays & Weekday.SUNDAY) > 0,
  }
}

export default parseWeekdays
